import React, { useState } from 'react'
import { 
  Button,
  Grid, 
  makeStyles, 
} from '@material-ui/core'
import { Redirect } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { startAlerta } from '../../../actions/ui/alertas';
import { AutorizacionesCard } from '../UI/AutorizacionesCard'
import { 
  PracticasLaboratorioSeleccionadas 
} from '../../turnos/recepcionDiaria/laboratorio/steps/PracticasLaboratorioSeleccionadas'
import { AutorizacionesConfirmacionLaboratorio } from './AutorizacionesConfirmacionLaboratorio';
import { setActiveStep, setShowForm } from '../../../actions/autorizaciones/Autorizaciones';
import { confirmSolicitudLaboratorioCab } from '../../../actions/turnos/laboratorio';
import { ESPECIALIDADES } from '../../../utils/constants';
import moment from 'moment';
import { ValidatorForm } from 'react-material-ui-form-validator';

const useStyles = makeStyles((theme) => ({
  rootBotonera: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "70%",
  },
  botonera: {
      marginTop: 25,
      marginBottom: 20,
      paddingBottom: 13
  },
}));

export const AutorizacionesPracticasEstadoLaboratorio = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { solicitudSeleccionada = {}, showForm = {}, activeStep } =
    useSelector((state) => state.autorizaciones
  );
  const { 
      practicasSeleccionadas: practicas, 
  } = useSelector((state) => state.laboratorio);

  const [redirect, setRedirect] = useState(false);
  const [esUrgente, setEsUrgente] = useState("noEsUrgente");
  const [fechaPrescripcion, setFechaPrescripcion] = useState(moment());

  const onClickConfirmarHandler = () => {
    const urgente = esUrgente === "esUrgente" ? true : false;
    if (esUrgente === "") {
      dispatch(startAlerta(`Seleccione el grado de importancia.`, "error"));
    } else {
      if (solicitudSeleccionada?.idSolicitud !== 0) {
        const solic = {
          urgente,
          practicas,
          fechaPrescripcion,
          idEspecialidad: ESPECIALIDADES.LABORATORIO,
          idAfiliado: solicitudSeleccionada.idAfiliado,
          idSolicitud: solicitudSeleccionada.idSolicitud,
          idDiagnostico: solicitudSeleccionada.idDiagnostico,
        }

        dispatch( confirmSolicitudLaboratorioCab(solic, setRedirect) );
      }
    }
  };

  const handleNext = () => {
    if(!showForm)
      dispatch( setShowForm(true) );  
    else
      onClickConfirmarHandler();        
  };

  const handleBack = () => {
    if(!showForm){
      dispatch( setShowForm(true) );
      dispatch( setActiveStep(activeStep - 1) );
    }
    else{
      dispatch( setShowForm(false) );  
    }
  };

  // console.log({solicitudSeleccionada, practicasLabo: practicas, fechaPrescripcion});

  return (
    <ValidatorForm onSubmit={handleNext}>
      <AutorizacionesCard width={"65%"}>
        {!showForm ? (
          <Grid item xs={12} style={{marginLeft: 15}}>
            <PracticasLaboratorioSeleccionadas />
          </Grid>
        ) : (
          <AutorizacionesConfirmacionLaboratorio 
            esUrgente={esUrgente} 
            setEsUrgente={setEsUrgente} 
            fechaPrescripcion={fechaPrescripcion}
            setFechaPrescripcion={setFechaPrescripcion}
          />
        )}      
        <div className={classes.rootBotonera}>
          <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.botonera}
          >
            <Button
              variant="contained"
              onClick={handleBack}
              color="secondary"
            >
              Anterior
            </Button>
            <Button
              variant="contained"
              color="primary"
              // onClick={handleNext}
              type={"submit"}
            >
              {showForm ? 'Confirmar' : 'Siguiente'}
            </Button>
          </Grid>
        </div>
        {redirect && (
          <Redirect
            to={{
              pathname: "/autorizaciones",
            }}
          />
        )}
      </AutorizacionesCard>
    </ValidatorForm>
  )
}
